module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    attrs: {
      "role": "primary"
    }
  }, [_c('div', {
    staticClass: "pane",
    class: {
      animate: _vm.animateTransition
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.animTouch) ? _c('div', {
    staticClass: "mxr-touch",
    on: {
      "click": function($event) {
        _vm.animTouch = false
      }
    }
  }, [_c('div', {
    staticClass: "mxr-touch__anim"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/swipe_leftright.svg"),
      "alt": "",
      "width": "50"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Sfoglia lateralmente "), _c('br'), _vm._v("per scoprire gli outfits")])]) : _vm._e()]), _vm._v(" "), _c('flickity', {
    ref: "flickity",
    class: ("mxr-slider-looks m-slider-looks--" + _vm.gender),
    style: ({
      height: (_vm.sectionHeight + "px")
    }),
    attrs: {
      "options": _vm.flickityOptions
    }
  }, _vm._l((_vm.looks[_vm.gender]), function(look, index) {
    return _c('div', {
      key: (index),
      staticClass: "cell",
      style: ({
        height: (_vm.sectionHeight + "px")
      }),
      attrs: {
        "data-src": look.images.large,
        "data-color": look.hex_color
      }
    }, [_c('div', {
      staticClass: "pane",
      style: ({
        background: ("linear-gradient(145deg, " + (_vm.hexToRGB(look.hex_color, 0)) + " 40%," + (_vm.hexToRGB(look.hex_color, 0.15)) + " 50%," + (_vm.hexToRGB(look.hex_color, 1)) + " 100%) 0 1000px no-repeat")
      }),
      attrs: {
        "data-look": (index)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mxr-slider-looks__title"
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v("Outfit")]), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [_vm._v("#" + _vm._s(_vm._f("padToTwo")(index)))])]), _vm._v(" "), _c('div', {
      staticClass: "cell__inner",
      style: ({
        height: (_vm.sectionHeight + "px")
      }),
      attrs: {
        "data-look": (index),
        "data-flickity-bg-lazyload": look.images.large
      }
    })])
  }))], 1), _vm._v(" "), _c('borders', {
    attrs: {
      "show-corners": false,
      "showGender": _vm.gender,
      "prevArrow": true,
      "nextArrow": true,
      "show-text": false,
      "show-dots": false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0beee204"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Looks.vue
// module id = 452
// module chunks = 1